module.exports = __webpack_public_path__ + "static/media/series-poster-tablet.6cac2361.jpg";